module.exports = __webpack_public_path__ + "img/icon_2@2x.822f94ad.png";